import React, { Component } from "react";
import Header from "../../Layout/Header/Header-loggedIn";
import Footer from "../../Layout/Footer/Footer";
import Timer from "react-compound-timer";
import Editions from "../Editions";
import Prize_winners from "../Prizes/Prize_winners";
import { authenticate, get_current_level } from "../../Utils/Utils";
// import logo from "../../Assets/img/150x30.png";

class PreStart extends Component {
  // constructor(props) {
  //   super(props);
  //   const { level_name, edition_id } = this.props.match.params;
  //   this.state = {
  //     artifact: "",
  //     level_name: level_name,
  //     edition_id: edition_id
  //   };
  // }

  async componentDidMount() {
    // if (authenticate()) {
    //   if (!parseInt(localStorage.getItem("starts_in")) || this.state.edition_id) {
    //     get_current_level(this.state.edition_id);
    //   }
    // } else {
    //   return (window.location = "/login");
    // }
    if (!authenticate()) {
      return (window.location = "/login");
    }
  }

  render() {
    return (
      <div className="PreStart">
        <Header />
        <div className="container mb-4">
          <div className="body">
            {/* {!!localStorage.getItem("starts_in") && ( */}
            {false && ( 
              <div>
                <div className="row d-flex justify-content-center pt-5 timers">
                  <Timer
                    initialTime={parseInt(localStorage.getItem("starts_in"))}
                    startImmediately={true}
                    direction="backward"
                    className={""}
                    formatValue={(value) =>
                      `${value < 10 ? `0${value}` : value}  `
                    }
                  >
                    {() => (
                      <div className="timer_box">
                        <React.Fragment>
                          <span className="hours">
                            {" "}
                            &nbsp; <Timer.Days />{" "}
                          </span>{" "}
                          &nbsp; : &nbsp;
                          <span className="hours">
                            {" "}
                            &nbsp; <Timer.Hours />{" "}
                          </span>{" "}
                          &nbsp; : &nbsp;
                          <span className="minutes">
                            {" "}
                            <Timer.Minutes />{" "}
                          </span>{" "}
                          &nbsp; : &nbsp;
                          <span className="seconds">
                            {" "}
                            <Timer.Seconds />{" "}
                          </span>
                        </React.Fragment>
                      </div>
                    )}
                  </Timer>
                </div>

                {/* <div className="d-xl-block d-lg-block d-md-block d-sm-none d-none prestart_timer_mobile">
                  <div className="row d-flex justify-content-center timer_txt pt-3">
                    <p>
                      <span> Days </span>
                      <span> Hours </span>
                      <span> &nbsp; Minutes </span>
                      <span> Seconds </span>
                    </p>
                  </div>
                </div> */}
{/* 
                <div className="d-xl-none d-lg-none d-md-none d-sm-block d-block">
                  <div className="row d-flex justify-content-center timer_txt pt-3">
                    <p>
                      <span className="day_txt"> Days </span>
                      <span className="hour_txt"> Hours </span>
                      <span className="mins_txt"> Mins </span>
                      <span className="sec_txt"> Secs </span>
                    </p>
                  </div>
                </div> */}
              </div>
            )}

            <div className="row d-flex justify-content-center">
              <h3 className="col-12 text-center pt-5">
                August 21, 2020 12:00 PM IST
              </h3>
              {/* <p className="col-lg-7 col-md-12  col-12 pb-3 text-center">
              </p> */}
              {/*<div className="col-12 text-center">
                <a href="#" className="btn btn-yellow">Start playing</a>
              </div>*/}
            </div>
            <Editions noHeader="true" noTitle="true" noFooter="true" />

            <h2 className="pt-5 text-center prizes_title">
              {" "}
              PRIZES FOR THE INAUGURAL EDITION{" "}
            </h2>
          </div>
          <div
            className="col-12"
            style={{ paddingLeft: "15px", paddingRight: "15px" }}
          >
            <Prize_winners />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default PreStart;
